import { slicePrefix } from '../config'

const createValue = slicePrefix('fulfillment-request')

export const config = {
  modelName: createValue(),
} as const
